import {
  interactions,
  stateMapperArgsSelectors,
  selection,
} from '#packages/stateManagement';
import * as util from '#packages/util';
import type { EditorAPI } from '#packages/editorAPI';
import { AnimationsApiKey } from '#packages/apis';

import { canSelectSectionLike } from '../selectors';

const {
  rootSels,
  otherSels,
  selector: { createSelector },
} = stateMapperArgsSelectors;

const { dsReadSel, editorAPIMouseSel, editorAPISel, editorStateSel } = rootSels;

const canShowSiteSegmentBoxSelector = createSelector(
  [otherSels.isPinModeSel, editorStateSel, dsReadSel, editorAPISel],
  (isPinMode, editorState, dsRead, editorAPI) =>
    !isPinMode &&
    !dsRead?.pages.popupPages.isPopupOpened() &&
    !interactions.selectors.isInInteractionMode(editorState) &&
    !editorAPI.componentFocusMode.isEnabled() &&
    !editorAPI.host.getAPI(AnimationsApiKey).isInScrubPreview(),
);

const shouldShowBoxWhenSectionActionsAreHovered = (editorAPI: EditorAPI) => {
  const selectedSection = editorAPI.sections.getSelectedSectionLike();
  const hoveredSection = editorAPI.sections.getHoveredSectionLike();
  if (selectedSection?.id === hoveredSection?.id) return true;
  return !selection.selectors.shouldHideSelectionWhenStageActionsHovered(
    editorAPI,
  );
};

export const shouldShowSelectedSiteSegmentBoxSel = createSelector(
  [
    canShowSiteSegmentBoxSelector,
    editorAPIMouseSel,
    editorStateSel,
    canSelectSectionLike,
  ],
  (canShowSiteSegmentBox, editorAPI, editorState, canSelectSectionLike) => {
    const siteSegmentToSelect =
      editorAPI.sections.getSelectedHeaderFooter() ||
      editorAPI.sections.getFocusedHeaderFooter();

    return (
      canShowSiteSegmentBox &&
      canSelectSectionLike &&
      Boolean(siteSegmentToSelect) &&
      util.spotlightStageUtils.canSelectCompConsideringSpotlightStage(
        editorAPI,
        selection.selectors.getFocusedContainer(editorState),
        siteSegmentToSelect,
      ) &&
      shouldShowBoxWhenSectionActionsAreHovered(editorAPI)
    );
  },
);

export const shouldShowHoveredSiteSegmentBoxSel = createSelector(
  [canShowSiteSegmentBoxSelector, editorAPIMouseSel],
  (canShowHeaderFooterBox, editorAPI) => {
    if (!canShowHeaderFooterBox) return false;

    return Boolean(editorAPI.sections.getHoveredHeaderFooter());
  },
);
